<!-- Global components -->
<app-loading-spinner />
<p-toast position="top-right" />

<!-- Auth pages layout (no header/footer) -->
<div
  *ngIf="isNotAuthRoute"
  class="flex flex-col min-h-screen w-full overflow-hidden"
>
  <main class="flex-grow flex items-center justify-center">
    <router-outlet />
  </main>
</div>

<!-- Authenticated pages layout (with header/footer) -->
<div *ngIf="!isNotAuthRoute" class="authenticated-layout">
  <!-- Fixed header (full width) -->
  <app-header class="header" />

  <!-- Main content (scrollable, centered) -->
  <main class="main-content">
    <div
      class="flex-1 flex flex-col"
      [ngClass]="{
        'container mx-auto px-5 sm:px-4 py-2': !isWidgetsRoute,
        'px-0': isWidgetsRoute,
        'iframe-scrollable': isIframeRoute,
      }"
    >
      <router-outlet />
    </div>
  </main>

  <!-- Fixed footer (full width) -->
  <app-footer class="footer" />
</div>
